import { Component, Injector, Input, OnInit } from '@angular/core';
import { FcItemModalBaseComponent, FcItemModalContextWithPrimaryKey, FcItemModalMode, FcItemModalService } from 'webcommon/find-control';
import { ApAlertService } from 'webcommon/core-ui';
import { Subject } from 'rxjs';
import { FindControlRepository } from 'webcommon/webapi';
import { finalize } from 'rxjs/operators';
import { ViewOptionDto } from 'webcommon/shared';
import { ViewOptionModalService } from './view-option-modal-service';

@Component({
  providers: [ApAlertService],
  selector: 'ap-view-option-modal',
  templateUrl: './view-option-modal.component.html',
  styleUrls: ['./view-option-modal.component.less']
})
export class ViewOptionModalComponent extends FcItemModalBaseComponent implements OnInit {
  @Input() selectedViewOptionData: ViewOptionDto;
  @Input() mode: 'findControl' | 'link' = 'findControl';
  private actionSubject$ = new Subject<string>();
  actionType$ = this.actionSubject$.asObservable();
  fcItemModalModeEnum = FcItemModalMode;
  isButtonDisabled = false;
  processFormType: 'new' | 'edit' | 'view' = 'view'; // Default state
  disabledSaveButton = false;

  constructor(
    private findControlRepository: FindControlRepository,
    private viewOptionModalService: ViewOptionModalService,
    private fcItemModalService: FcItemModalService,
    public injector: Injector
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.determineFormType();
    this.loadActionButtonConfig();
  }

  loadActionButtonConfig() {
    const selectedItem = this.fcModalItemContext as FcItemModalContextWithPrimaryKey;
    if (
      selectedItem?.selectedFindItemPk
      ===
      this.viewOptionModalService?.defaultFilterOptionId ||
      this.mode === 'link'
    ) {
      this.disabledSaveButton = true;
    }
  }

  override onCancel(): void {
    this.apUserCancel();
  }

  private determineFormType(): void {
    this.processFormType = this.getActionType();
  }


  getActionType(): 'view' | 'edit' | 'new' {
    const findControlMode = this.fcModalItemContext?.mode ?? 0;
    switch (findControlMode) {
      case this.fcItemModalModeEnum.Modify:
        return 'edit';
      case this.fcItemModalModeEnum.New:
        return 'new';
      default:
        return 'view';
    }
  }

  onSaved(optionId: string): void {
    this.findControlRepository.getSelectedItems('ListRPNOptions', [optionId])
      .pipe(
        this.takeUntilDestroy(),
        finalize(() => (this.isSaving = false))
      )
      .subscribe({
        next: selectedItems => super.apClose(selectedItems.Rows[0])
      });
  }

  saveAndApply(): void {
    this.isSaving = true;
    const emissionType = 'saveApply';
    this.actionSubject$.next(emissionType);
    this.fcItemModalService.setViewOptionType(emissionType);
  }

  save(): void {
    this.isSaving = true;
    this.actionSubject$.next(this.processFormType);
    this.fcItemModalService.setViewOptionType(this.processFormType === 'new' ? 'new' : 'save');
  }

  handleClickValidation(isAllowed: boolean): void {
    this.isButtonDisabled = isAllowed;
  }

  getModalTitle(): string {
    const RpnOption = 'RPN Viewing Options';
    if (this.mode === 'link') {
      return `Modify ${RpnOption} - ${this.selectedViewOptionData.Name}`;
    } else {
      switch (this.fcModalItemContext?.mode) {
        case this.fcItemModalModeEnum.Modify:
          return `Modify ${RpnOption} - ${this.fcModalItemContext.selectedFindItemName}`;
        case this.fcItemModalModeEnum.New:
          return `New ${RpnOption}`;
        default:
          return `${RpnOption}`;
      }
    }
  }
}
